export default __webpack_public_path__ + "static/media/15.982b0902.jpg";